import React from 'react';
import { COMPANY_INFO } from '../data/mockData';

export default function ContactBoxes({ className = "" }) {
  return (
    <div className={`grid grid-cols-1 lg:grid-cols-2 gap-6 ${className}`}>
      {/* Telefonkasse */}
      <a 
        href={`tel:${COMPANY_INFO.phoneRaw}`} 
        aria-label="Ring til os på 22 72 87 23 for service eller fejlfinding"
        className="group relative flex items-center p-6 md:p-8 bg-white border-2 border-slate-200/80 rounded-2xl shadow-sm hover:shadow-md hover:border-sky-600 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
      >
        <div className="flex-shrink-0 w-14 h-14 md:w-16 md:h-16 bg-sky-50 group-hover:bg-sky-600 text-sky-700 group-hover:text-white rounded-xl flex items-center justify-center transition-colors duration-300 mr-5 shadow-inner">
          <i className="fa-solid fa-phone-volume text-2xl md:text-3xl" aria-hidden="true"></i>
        </div>
        <div>
          <span className="block text-xs font-bold uppercase tracking-wider text-sky-700 mb-1">
            Har du brug for service eller fejlfinding?
          </span>
          <span className="text-xl md:text-2xl font-extrabold text-slate-900 group-hover:text-sky-700 transition-colors duration-200 block nowrap-contact">
            Ring på 22 72 87 23
          </span>
          <span className="inline-flex items-center text-xs font-semibold text-slate-500 group-hover:text-sky-600 mt-1">
            <span>Åbent for akutte og planlagte opgaver</span>
            <i className="fa-solid fa-arrow-right text-xs ml-1.5 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true"></i>
          </span>
        </div>
      </a>

      {/* E-mailkasse */}
      <a 
        href={`mailto:${COMPANY_INFO.email}`} 
        aria-label="Send en e-mail til k-to@outlook.dk"
        className="group relative flex items-center p-6 md:p-8 bg-white border-2 border-slate-200/80 rounded-2xl shadow-sm hover:shadow-md hover:border-sky-600 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2"
      >
        <div className="flex-shrink-0 w-14 h-14 md:w-16 md:h-16 bg-slate-100 group-hover:bg-slate-900 text-slate-700 group-hover:text-white rounded-xl flex items-center justify-center transition-colors duration-300 mr-5 shadow-inner">
          <i className="fa-solid fa-envelope-open-text text-2xl md:text-3xl" aria-hidden="true"></i>
        </div>
        <div>
          <span className="block text-xs font-bold uppercase tracking-wider text-slate-600 mb-1">
            Send en forespørgsel
          </span>
          <span className="text-xl md:text-2xl font-extrabold text-slate-900 group-hover:text-sky-700 transition-colors duration-200 block nowrap-contact">
            {COMPANY_INFO.email}
          </span>
          <span className="inline-flex items-center text-xs font-semibold text-slate-500 group-hover:text-sky-600 mt-1">
            <span>Svarer hurtigt på alle henvendelser</span>
            <i className="fa-solid fa-arrow-right text-xs ml-1.5 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true"></i>
          </span>
        </div>
      </a>
    </div>
  );
}
